/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject, Injectable, InjectionToken } from '@angular/core';

export const LOGGER_PROVIDERS = new InjectionToken<Logger[]>('LOGGER_PROVIDERS');

export interface Logger {
    debug: any;
    info: any;
    warn: any;
    error: any;
    trace: any;
}

@Injectable({providedIn: 'root'})
export class LoggerService {
    private providers = inject(LOGGER_PROVIDERS);
    
    debug(...args: any[]) {
        this.log('debug', args);
    }

    info(...args: any[]) {
        this.log('info', args);
    }
    warn(...args: any[]) {
        this.log('warn', args);
    }
    error(...args: any[]) {
        this.log('error', args);
    }
    trace(...args: any[]) {
        this.log('trace', args);
    }

    log(level: string, args: any[]) {
        this.providers.forEach(provider => {
            provider[level](...args);
        })
    }
}
